var map = {
	"./afghanistan-small.jpg": 89,
	"./armenia-small.jpg": 90,
	"./azerbeidzan-small.jpg": 91,
	"./belarus-small.jpg": 92,
	"./georgia-small.jpg": 93,
	"./iraq-small.jpg": 94,
	"./kazakhstan-small.jpg": 95,
	"./kyrgyzstan-small.jpg": 96,
	"./moldova-small.jpg": 97,
	"./mongolia-small.jpg": 98,
	"./russia-small.jpg": 99,
	"./tajikistan-small.jpg": 100,
	"./turkmenistan-small.jpg": 101,
	"./ukraine-small.jpg": 102,
	"./uzbekistan-small.jpg": 103,
	"./worldwide-small.jpg": 104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88;